import React from 'react';
import SeleccionarSituacion from '../modals/SeleccionarSituacion';
import EnviarCorreo from '../../pages/Inmatriculacion/enviarCorreo';
import VerFacturas from '../../pages/Inmatriculacion/verFacturas';
import VerErrores from '../../pages/Inmatriculacion/verErrores';
import SeleccionarAdjunto from '../../pages/Inmatriculacion/SeleccionarAdjunto';

function showModal(modalName, that) {

    switch (modalName) {
        case 'seleccionar-situacion':
            return (
                <SeleccionarSituacion
                    closeModal={that.closeModal}
                    tipoPlantilla={that.state.tipoPlantilla}
                    seleccionarSituacionItem={that.seleccionarSituacionItem}
                    procesarSituacion={that.procesarSituacion}
                />
            );
        case 'enviar-correo':
            return (
                <EnviarCorreo
                    closeModal={that.closeModal}
                    enviarCorreo={that.enviarCorreo}
                    domain = {that.state.selectRow}
                    registros={that.state.dataRows}
                />
            );
        case 'ver-errores':
            return (
                <VerErrores
                    registros={that.state.errores}
                    closeModal={that.closeModal}
                />
            );
        case 'ver-facturas':
            return (
                <VerFacturas
                    seleccionarSituacionItem={that.seleccionarSituacionItem}
                    showError={that.showError}
                    domain = {that.state.selectRow}
                    closeModal={that.closeModal}
                />
            );
        case 'seleccionar-adjunto':
            return (
                <SeleccionarAdjunto
                    domain = {that.state.selectRow}
                    changeTipoPlantilla = {that.changeTipoPlantilla}
                    closeModal={that.closeModal}
                    onDrop={that.onDrop}
                />
            );
        default:
            return null;
    }
}

export default showModal;



// WEBPACK FOOTER //
// ./src/pages/Inmatriculacion/showModal.js